import React from 'react';
import { Tabs, Typography } from 'antd';
import WalletForm from './walletForm';
import CardBankForm from './cardBankForm';
import BankForm from './bankForm';

const { Title } =Typography;

const formComponents = [
    {
        title : "Paiement mobile",
        component : <WalletForm/>
    },
    {
        title : 'Paiement carte bancaire',
        component : <CardBankForm/>
    },
    {
        title : 'Paiement bancaire direct',
        component : <BankForm/>
    }
]

const AddPaymentForm = () => (
  <Tabs
    defaultActiveKey="1"
    centered
    items={formComponents.map((item, i) => {
      const id = String(i + 1);
      if(item) {
        return {
            label: <Title level={5}>{item.title}</Title>,
            key: id,
            children: item.component,
        }
      }else {
        <div> Test</div>
      }
    })}
  />
);
export default AddPaymentForm;